<template>
  <div>
    <v-card
    outlined>
      <v-card-title class="light-blue--text justify-space-between">
        <h3 class="headline">Property Detail</h3>
        <v-btn aria-label="Edit Property Details" v-if="!propertyLoading" small icon :to="'/properties/edit/'+propertyID" color="grey">
          <v-icon >mdi-pencil</v-icon>
        </v-btn>
      </v-card-title>
      <template v-if="propertyLoading">
        <div class="text-center pa-4">
          <v-progress-circular color="light-blue" indeterminate/>
        </div>
      </template>
      <template v-else>
        <div class="px-5">
          <v-img :src="googleEmbed">
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <div class="my-2 mb-3">
            <h4 class="text-uppercase">Property Address</h4>
            <span class="d-block">{{propertyAddressLineOne}},</span>
            <span class="d-block">{{propertyCity}}, {{propertyState}} {{propertyZip}}</span>
          </div>
          <v-divider></v-divider>
          <div class="my-2">
            <h4 class="text-uppercase my-3">Tenant Information</h4>
            <span class="d-block">
            <span class="font-weight-bold">Name:</span> {{propertyTenantFullName}}
          </span>
            <span class="d-block">
            <span class="font-weight-bold">Phone Number:</span> {{propertyTenantPhone}}
          </span>
            <span class="d-block">
            <span class="font-weight-bold">Cell Number:</span> {{propertyTenantCellPhone}}
          </span>
            <span class="d-block">
            <span class="font-weight-bold">Email Address:</span> {{propertyTenantEmail}}
          </span>
          </div>
          <v-divider></v-divider>
        </div>
        <v-expansion-panels flat v-if="rentLoading" :value="0">
          <v-expansion-panel
            v-for="(year) in Object.keys(rentOptions).reverse()"
            :key="year"
            :active-class="$props.darkMode ? 'grey darken-3' : 'la-creme'"
          >
            <v-expansion-panel-header  >
              <h4 class="text-uppercase my-3">Rent Payments ({{year}})</h4>
            </v-expansion-panel-header>
            <v-expansion-panel-content :color="$props.darkMode ? 'grey darken-4' : 'white'">
              <v-row>
                <v-col v-for="(monthObj,month) in rentOptions[year]" :key="year+month" cols="6" sm="3" lg="2">
                  <v-checkbox
                    :label="monthFromNumber(month)"
                    color="light-blue"
                    :indeterminate="!monthObj.enabled"
                    :disabled="!monthObj.enabled"
                    :input-value="monthObj.status"
                    @click="toggleRentPayment(year,month)"
                    hide-details
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-expansion-panel-content>

          </v-expansion-panel>
        </v-expansion-panels>
      </template>


    </v-card>
  </div>
</template>

<script>
  import moment from 'moment';
  import { mapActions, mapGetters } from "vuex";

  export default {
    name: 'PropertyDetail',
    props: {
      darkMode:{
        type:Boolean,
        default: false
      },
      id: {
        type: String,
        default: null
      },
    },

    data: () => ({
      rent: null,
      rentLoading:true,
    }),
    computed:{
      googleEmbed() {
        return `https://maps.googleapis.com/maps/api/staticmap?zoom=19&center=${this.urlEncodedAddress}&size=800x300&maptype=hybrid&markers=|${this.urlEncodedAddress}&key=AIzaSyBgKXhBzfGbOi2WvawnAn2D4SEwve5Qkx0`;
      },
      urlEncodedAddress(){
        return `${this.propertyAddressLineOne.replace(/\s/g, '+').replace('#','APT+')}+${this.propertyCity}+${this.propertyState}+${this.propertyZip}`;
      },
      rentOptions(){
        let data = {};
        let yearBooster = 0;
        if (moment().format('M') > 11){
          yearBooster = 1;
        }

        let year = parseInt(this.propertyStartDate.substr(0, 4));

        for (var i = year; i <= (new Date().getFullYear() + yearBooster); i++) {
          data[i] = this.createRentYearObject(i);
        }
        return data;
      },


      ...mapGetters([
        'propertyAddressLineOne',
        'propertyCity',
        'propertyStartDate',
        'propertyState',
        'propertyZip',
        'propertyTenantPhone',
        'propertyTenantCellPhone',
        'propertyTenantFullName',
        'propertyTenantEmail',
        'propertyRent',
        'propertyID',
        'property',
        'propertyLoading',
        'devMode'
      ]),

    },
    created(){
      this.initialize();
    },
    watch: {
      'propertyLoading': function(value) {
        if (value === false){
          this.initialize();
        }
      }
    },
    methods:{
      initialize() {
        this.rent = this.propertyRent;
      },
      toggleRentPayment(year, month){
        console.log(year);
        if(!Object.prototype.hasOwnProperty.call(this.rent,year)){
          this.rent[year] = {};
        }
        if(!Object.prototype.hasOwnProperty.call(this.rent[year],month)){
          this.rent[year][month] = false;
        }
        this.rent[year][month] = !this.rent[year][month];
        this.updatePropertyRent(this.rent);
      },
      checkMonthPaymentStatus(year, month){
        let status = false;
        if(Object.prototype.hasOwnProperty.call(this.rent,year)){
          if(Object.prototype.hasOwnProperty.call(this.rent[year],month)){
            status = this.rent[year][month];
          }
        }
        return status;
      },
      monthFromNumber(num){
        return moment(num,'MM').format('MMM');
      },
      createRentYearObject(year){
        let startYear = parseInt(this.propertyStartDate.substr(0, 4));
        let startMonth = parseInt(this.propertyStartDate.substr(5,2));

        let data = {};

        for (var i = 1; i <= 12 ; i++) {
            data[i] = {
              enabled: (year > startYear || (year === startYear && i >= startMonth) ),
              status: (this.checkMonthPaymentStatus(year, i)),
           };
        }
        return data;
      },
      ...mapActions([
        'updatePropertyRent',
        'deleteAssociatedItems'
      ]),
    }
  }
</script>

<style lang="scss" scoped>

</style>